import ReactGA4 from 'react-ga4'
import { UaEventOptions } from 'react-ga4/types/ga4'
import TagManager from 'react-gtm-module'
import Tracker from 'tracker'
import AllTrackers from './AllTrackers'
import { EnrichedEventData } from './GA/types'

export interface UserParams {
  /** Typically the object that was interacted with (e.g. 'Video') */
  category: string
  /** The type of interaction (e.g. 'play') */
  action: string
  /** Useful for categorizing events (e.g. 'Fall Campaign') */
  label?: string
  /** A numeric value associated with the event (e.g. 42) */
  value?: number
}

export const initializeMerchantGA4 = (
  ga4Id: string | null,
  customerId: string,
  enrichedMerchantData: Partial<EnrichedEventData>
) => {
  if (ga4Id) {
    AllTrackers.getInstance().initMerchantGA4Tracker(
      ga4Id,
      'merchantGA4Tracking',
      enrichedMerchantData,
      customerId
    )
  }
}

export const initializeTagManager = (gtmId: string | null) => {
  if (gtmId) {
    TagManager.initialize({ gtmId })
  }
}

export const initializeSlerpGA4 = (
  customerId: string,
  enrichedMerchantData: Partial<EnrichedEventData>
) => {
  AllTrackers.getInstance().initSlerpGA4Tracker(
    process.env.REACT_APP_GA4_ID || '',
    'slerpGA4Tracker',
    enrichedMerchantData,
    customerId
  )
}

export const initializeGoogleConversion = (
  adsId: string | null,
  conversionId: string | null
) => {
  if (adsId && conversionId) {
    // Google ads initialization is on slerp's v2.html.eex
    Tracker.getInstance().setGoogleConversionId(conversionId)
  }
}

export const trackUserActionsGA4 = (
  userParams: UserParams,
  trackerName: string
) => {
  if (checkTracker(trackerName)) {
    const eventParams: UaEventOptions = {
      action: userParams.action,
      category: userParams.category || '',
      label: userParams.label,
      value: userParams.value
    }
    ReactGA4.event(eventParams, [trackerName])
  }
}

export const trackGA4ProductListViewed = (trackerName: string) => {
  if (checkTracker(trackerName)) {
    const { domain, store } = setup()

    ReactGA4.event(
      {
        category: 'Product List',
        action: 'Product List Viewed',
        label: `${domain} / ${store}`
      },
      [trackerName]
    )
  }
}

const setup = () => {
  let domain: string | null = null
  let store: string | null = null

  const root = document.getElementById('root')

  if (root) {
    domain = root.getAttribute('domain')
    store = root.getAttribute('store')
  }

  return { domain, store }
}

const checkTracker = (trackerName: string) => {
  switch (trackerName) {
    case 'slerpGA4Tracking':
      // TEMP: do not track custom events
      return false
    // return (
    //   Tracker.getInstance().slerpGA4Enabled ||
    //   AllTrackers.getInstance().slerpGA4Tracker.isTrackingEnabled
    // )

    case 'merchantGA4Tracking':
      // TEMP: do not track custom events
      return false
    // return (
    //   Tracker.getInstance().merchantGA4Enabled ||
    //   AllTrackers.getInstance().merchantGA4Tracker.isTrackingEnabled
    // )

    default:
      return false
  }
}
